'use strict';

function us(type) {
  const ww = window.innerWidth;
  const wh = window.innerHeight;
  const ws = window.pageYOffset;

  switch(type) {
    case 'ww':
      return ww;
    case 'wh':
      return wh;
    case 'ws':
      return ws;
    default:
      break;
  }
}

function isMobile(device) {
  var isMobile = {
    android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    blackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    iOSMobile: function () {
      return navigator.userAgent.match(/iPhone|iPod/i);
    },
    iOSTablet: function () {
      return navigator.userAgent.match(/iPad/i);
    },
    opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    mobileOnly: function () {
      return (isMobile.android() || isMobile.blackBerry() || isMobile.iOSMobile() || isMobile.opera() || isMobile.windows());
    },
    all: function () {
      return (isMobile.android() || isMobile.blackBerry() || isMobile.iOS() || isMobile.opera() || isMobile.windows());
    },
  };
  switch(device) {
    case 'android':
      return isMobile.android();
    case 'blackBerry':
      return isMobile.blackBerry();
    case 'iOS':
      return isMobile.iOS();
    case 'opera':
      return isMobile.opera();
    case 'windows':
      return isMobile.windows();
    case 'mobileOnly':
      return (isMobile.android() || isMobile.blackBerry() || isMobile.iOSMobile() || isMobile.opera() || isMobile.windows());
    case 'all':
      return (isMobile.android() || isMobile.blackBerry() || isMobile.iOS() || isMobile.opera() || isMobile.windows());
    default:
      break;
  }
}

function setLang() {
  // function getParameterByName(name, url) {
  //   if (!url) url = window.location.href;
  //   name = name.replace(/[\[\]]/g, "\\$&");
  //   var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
  //   results = regex.exec(url);
  //   if (!results) return null;
  //   if (!results[2]) return '';
  //   return decodeURIComponent(results[2].replace(/\+/g, " "));
  // }

  // const getLang = getParameterByName('lang');


  const getLang = location.pathname.substr(1, 3);  // local site
  // const getLang = location.pathname.substr(17, 2);  // local site

  // const getLang = location.pathname.substr(12, 2); // live site

  // const getLang = location.pathname.substr(16, 2); // dev site
  var currentLang;

  switch (getLang) {
    case null:
      currentLang = 'en';
      document.documentElement.setAttribute('lang', 'en');
      return currentLang;
    case 'tc':
      currentLang = 'tc';
      document.documentElement.setAttribute('lang', 'zh-Hant');
      return currentLang;
    case 'sc':
      currentLang = 'sc';
      document.documentElement.setAttribute('lang', 'zh-Hans');
      return currentLang;
    default:
      currentLang = 'en';
      document.documentElement.setAttribute('lang', 'en');
      return currentLang;
      break;
  }
}

// function parsedData(entries) {
//   var moment = require('moment');
//
//   let data = {
//     data: [],
//   };
//
//   data = entries.map(data => ({
//     // event_end_ts: moment.unix(dataJuly.event_end_ts).format('hh:mma'),
//     event_start_ts: moment.unix(data.event_start_ts).format('hh:mma'),
//     event_start_date: moment.unix(data.event_start_ts).format('DD/M'),
//     event_ticket: data.event_ticket,
//     id: data.id,
//     total_booked: data.total_booked,
//   }));
//
//   return data;
// }

//return an array of objects according to key, value, or key and value matching
function getObjects(obj, key, val) {
  var objects = [];
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (typeof obj[i] == 'object') {
      objects = objects.concat(getObjects(obj[i], key, val));
    } else
    //if key matches and value matches or if key matches and value is not passed (eliminating the case where key matches but passed value does not)
    if (i == key && obj[i] == val || i == key && val == '') {
      objects.push(obj);
    } else if (obj[i] == val && key == ''){
      //only add if the object is not already in the array
      if (objects.lastIndexOf(obj) == -1){
        objects.push(obj);
      }
    }
  }
  return objects;
}
//return an array of values that match on a certain key
function getValues(obj, key) {
  var objects = [];
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (typeof obj[i] == 'object') {
      objects = objects.concat(getValues(obj[i], key));
    } else if (i == key) {
      objects.push(obj[i]);
    }
  }
  return objects;
}

//return an array of keys that match on a certain value
function getKeys(obj, val) {
  var objects = [];
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (typeof obj[i] == 'object') {
      objects = objects.concat(getKeys(obj[i], val));
    } else if (obj[i] == val) {
      objects.push(i);
    }
  }
  return objects;
}

const freezeAction = (e) => {
  e.preventDefault();
};

function disableTouchMove(action) {
  if (action === true) {
    document.body.addEventListener('touchmove', freezeAction, false);
    // console.log('disable true');
  } else {
    document.body.removeEventListener('touchmove', freezeAction, false);
    // console.log('disable false');
  }
}

function detectIE() {
  // ie 6-11
  if(navigator.userAgent.indexOf('MSIE')!==-1
|| navigator.appVersion.indexOf('Trident/') > 0){
   /* Microsoft Internet Explorer detected in. */
  //  console.log('ie');
    document.documentElement.classList.add('ie');
    return true;
  }
}

function iOSVersion() {
    var match = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/),
        version;

    if (match !== undefined && match !== null) {
        version = [
            parseInt(match[1], 10),
            parseInt(match[2], 10),
            parseInt(match[3] || 0, 10)
        ];
        return parseFloat(version.join('.'));
    }
    return false;
}

function sortByDate(data) {
  const entries = data;

  // sort content by date
  entries.sort((a, b) => {
    const itemA = a.dateID.replace(/[^A-Z0-9]+/ig, '');
    const itemB = b.dateID.replace(/[^A-Z0-9]+/ig, '');
    if (itemA < itemB) {
      return 1;
    }
    if (itemA > itemB) {
      return -1;
    }
    return 0;
  });

  return entries;
}

export {
  isMobile,
  setLang,
  parsedData,
  getObjects,
  getValues,
  getKeys,
  us,
  disableTouchMove,
  detectIE,
  iOSVersion,
  sortByDate,
};



// WEBPACK FOOTER //
// ./src/utils.js